// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__yTb17","label":"styles_label__SZSa4","input":"styles_input__uWNs0","btn_submit":"styles_btn_submit__SOvoI"};